import { useElectorates } from "@/components/ElectorateMap";

const STATES = ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"];

export const StateFilter = ({ value, onChange, selected, onPick }) => {
  const { data: stats = [] } = useElectorates();
  const counts = stats.reduce((a, s) => ({ ...a, [s.state]: (a[s.state] || 0) + 1 }), {});
  const list = value ? stats.filter((s) => s.state === value).sort((a, b) => a.name.localeCompare(b.name)) : [];

  return (
    <div data-testid="state-filter">
      <div className="flex flex-wrap gap-2">
        <button type="button" onClick={() => onChange("")} data-testid="state-chip-all" className={`h-9 px-4 rounded-full text-xs font-semibold border transition-colors ${!value ? "bg-[#1B2A41] border-[#1B2A41] text-[#FDFBF7]" : "border-[#D8D2C4] text-[#1B2A41] hover:border-[#8FA58A] bg-[#FAF8F2]"}`}>
          All 150
        </button>
        {STATES.map((st) => (
          <button type="button" key={st} onClick={() => onChange(value === st ? "" : st)} data-testid={`state-chip-${st}`} className={`h-9 px-4 rounded-full text-xs font-semibold border transition-colors ${value === st ? "bg-[#E2705A] border-[#E2705A] text-[#FDFBF7]" : "border-[#D8D2C4] text-[#1B2A41] hover:border-[#8FA58A] bg-[#FAF8F2]"}`}>
            {st} <span className="opacity-70 font-type">· {counts[st] ?? "–"}</span>
          </button>
        ))}
      </div>
      {value && (
        <div data-testid="state-electorate-list" className="mt-3 rounded-2xl bg-[#FAF8F2] border border-[#D8D2C4] p-3">
          <p className="font-type text-[11px] uppercase tracking-[0.25em] text-[#5A7355] mb-2">All {list.length} electorates in {value} — metro seats are tiny on the map, so pick them here</p>
          <div className="flex flex-wrap gap-1.5">
            {list.map((s) => (
              <button type="button" key={s.name} onClick={() => onPick(s.name)} data-testid={`state-list-${s.name}`} className={`h-8 px-3 rounded-full text-xs border transition-colors ${selected === s.name ? "bg-[#1B2A41] border-[#1B2A41] text-[#FDFBF7]" : "bg-white border-[#D8D2C4] text-[#1B2A41] hover:border-[#E2705A]"}`}>
                {s.name} <span className="font-type opacity-70">{s.count}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
